import React from "react";
import { BsFillArrowRightSquareFill } from "react-icons/bs";
import { MdHomeWork } from "react-icons/md";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useMutation, useQuery } from "react-query";
import { useHomeContext } from "../../context/HomeContext";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import { useThemeContext } from "../../context/ThemeContext";
const Dashboard = () => {
  const { token, user } = useAuth();
  const {currentMode,setCurrentMode} = useThemeContext()
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const dashboardData = useQuery(
    ["dashboardDataApi"],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}admin/dashboard`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );

  console.log(dashboardData?.data?.data?.data);
  return (
    <>
      <div className="p-5">
        <h1 className=" text-dark-color dark:text-white  font-bold text-2xl">
          Dashboard
        </h1>
        <div className="grid grid-cols-1 md:gris-cols-2 xl:grid-cols-4 gap-5 pt-3">
          {/* first */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Total Properties 
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalProperties}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={70}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#216fed`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/properties"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#216fed]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* second */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Total Companies
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalCompanies}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={40}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#38e25d`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/companies"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#38e25d]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* third */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Total Agents 
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalAgent}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={60}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#ff8723`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/agents"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#ff8723]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>

          {/* four */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-lg">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white  whitespace-pre-wrap">
                  Total Users
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalUsers}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={60}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#333e4b`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/users"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#333e4b]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* fifth */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Sold Properties 
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalSoldProperties}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={70}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#216fed`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/properties"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#216fed]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* six */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Rented Properties 
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalRentedProperties}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={70}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#38e25d`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/properties"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#38e25d]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* seven */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-2xl">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white ">
                  Aded Properties 
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.totalFeaturedProperties}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={70}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#ff8723`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/properties"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#ff8723]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
          {/* eight */}
          <div className="relative flex flex-col bg-white dark:bg-secondary-dark-bg  rounded-lg">
            <div className="flex items-center justify-between p-5 pb-10">
              <div className="flex flex-col items-start space-y-2">
                <h1 className="text-[#8aa1ad] font-semibold capitalize dark:text-white  whitespace-pre-wrap">
                  Banners
                </h1>
                {dashboardData.isFetched ? (
                  <p className="font-bold text-dark-color dark:text-white text-2xl">
                    {dashboardData?.data?.data?.data?.banners}
                  </p>
                ) : (
                  <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                )}
              </div>
              <div className="h-24 w-24">
                <CircularProgressbar
                  value={60}
                  maxValue={100}
                  strokeWidth={25}
                  styles={buildStyles({
                    // rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: `#333e4b`,
                    textColor: "#f88",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
              </div>
            </div>

            <Link
              to="/banner"
              className="absolute bottom-0 w-full flex items-center justify-center space-x-2 rounded-b-md
cursor-pointer bg-[#333e4b]  p-1"
            >
              <span className="font-normal capitalize text-white">
                see more
              </span>
              <BsFillArrowRightSquareFill size={20} className="text-white" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
